export default [
  'yd',
  'yandex-geoadv',
  'yandex-market',
  'trafficjunky',
  'marketgid',
  'gnezdo',
  'adsterra',
  'snapchat',
  'tinkoff',
  'otm',
  'targetmail',
  'bigo-ads',
  'appnext',
  'avito',
  'petal-ads',
  'mi-ads',
  'apple-search-ads',
  'wowblogger',
  'yandex-zen',
  'vk-adblogger',
  'mytargetint',
]
